import amex from './amex.png';
import defaultCard from './default.png';
import mastercard from './mastercard.png';
import visa from './visa.png';
import discover from './discover.jpg';

export const cardLogos = new Map(
  Object.entries({ amex, default: defaultCard, mastercard, visa, discover }),
);
